module.exports = __webpack_public_path__ + "img/20190713124512194.65da3b10.png";